import { ColumnParametersType } from '@types'

export const removeIdsFromColumnParameters = (parameters?: ColumnParametersType) => {
  if (!parameters) {
    return []
  }

  return parameters?.map(item => {
    const { id, ...props } = item

    return {
      ...props,
      param: {
        ...props.param,
        id: undefined,
        properties: props.param?.properties?.map(item => {
          const { id, ...props } = item

          return props
        }),
      },
    }
  })
}
